export type {
  ExtractPageResult,
  GetBlockPointer,
  ICCPointer,
  IsDataAvailPointer,
  PageNumber,
  PageResult,
  PdfReaderPointer,
  PlotColor,
  PlotMediaEntry,
  PlotPageEntry,
  PlotShape,
  PlotShapeMedia,
  PlotShapePath,
  PlotShapeRect,
  PlotShapeText,
} from "../types/Types"

import type { ProvisionAPI } from "@pdfking/library-core"
import type { CreateFunctions } from "../generated/Encoders"
export type PdfiumAPI = ProvisionAPI<ReturnType<typeof CreateFunctions>>
